import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepo = ProductRepositoryImpl.getInstance();

interface AddProductToStockNotificationProps {
  readonly onSuccess: () => void;
  readonly onError: (error: unknown) => void;
}

const useAddProductToStockNotification = ({ onSuccess, onError }: AddProductToStockNotificationProps) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: (variantId: string) => {
        return productRepo.addToStockNotification(auth, variantId, apiUrl);
      },
    },
    queryClient,
  );

  const addProductToStockNotification = useCallback(
    (variantId: string) => {
      mutation.mutate(variantId, { onSuccess, onError });
    },
    [mutation, onSuccess, onError],
  );

  return addProductToStockNotification;
};

export { useAddProductToStockNotification };
